module.exports = __webpack_public_path__ + "static/media/ethereum.9bb38c82.png";